import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://23aae9c4044adb837aee8f3d604ce21e@o1159374.ingest.us.sentry.io/4511661162299392",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Set tracesSampleRate to 1.0 to capture 100% of transactions for tracing.
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/hydro.sakeena\.io\/api/],
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
